document.addEventListener('DOMContentLoaded', () => {
  const root = window.EL.root || '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.EL.currency }).format(value / 100) + ' ' + window.EL.currency;
  const selectedAddons = container => Array.from(container.querySelectorAll('[data-addon-card]')).filter(card => card.querySelector('[data-addon-checkbox]').checked).map(card => ({ id: Number(card.querySelector('[data-addon-variant]').value), quantity: 1 }));
  const addonTotal = container => Array.from(container.querySelectorAll('[data-addon-card]')).reduce((sum, card) => sum + (card.querySelector('[data-addon-checkbox]').checked ? Number(card.querySelector('[data-addon-variant]').selectedOptions[0].dataset.price) : 0), 0);
  const postCart = async (route, payload) => {
    const response = await fetch(root + 'cart/' + route + '.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || window.EL.error);
    return data;
  };
  document.querySelectorAll('[data-addon-root]').forEach(container => {
    let addingToCart = false;
    container.hidden = false;
    container.querySelectorAll('[data-addon-card]').forEach(card => {
      const select = card.querySelector('[data-addon-variant]');
      const checkbox = card.querySelector('[data-addon-checkbox]');
      const refresh = () => {
        const option = select.selectedOptions[0];
        card.classList.toggle('is-selected', checkbox.checked);
        card.querySelector('[data-addon-price]').textContent = window.EL.addPrice.replace('__PRICE__', option.dataset.priceText);
        const image = card.querySelector('img');
        if (image && option.dataset.imageSrc) { image.removeAttribute('srcset'); image.src = option.dataset.imageSrc; }
        const cartButton = container.querySelector('[data-cart-addon-button]');
        if (cartButton) cartButton.disabled = addingToCart || selectedAddons(container).length === 0;
        container.dispatchEvent(new CustomEvent('addons:change', { bubbles: true }));
      };
      select.addEventListener('change', refresh);
      checkbox.addEventListener('change', refresh);
      refresh();
    });
    const cartButton = container.querySelector('[data-cart-addon-button]');
    if (cartButton) cartButton.closest('form').addEventListener('submit', event => {
      if (addingToCart) event.preventDefault();
    });
    if (cartButton) cartButton.addEventListener('click', async () => {
      const form = cartButton.closest('form');
      const message = container.querySelector('[data-addon-message]');
      const items = selectedAddons(container);
      if (addingToCart || !items.length || !form.reportValidity()) return;
      addingToCart = true;
      const checkoutButtons = Array.from(form.querySelectorAll('button[type="submit"]'));
      const initialDisabled = checkoutButtons.map(button => button.disabled);
      checkoutButtons.forEach(button => { button.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      cartButton.disabled = true;
      cartButton.textContent = window.EL.adding;
      message.textContent = '';
      try {
        const updates = {};
        form.querySelectorAll('[data-cart-key]').forEach(row => { updates[row.dataset.cartKey] = Number(row.querySelector('input[name="updates[]"]').value); });
        await postCart('update', { updates });
        await postCart('add', { items });
        window.location.assign(root + 'cart');
      } catch (error) {
        addingToCart = false;
        form.removeAttribute('aria-busy');
        checkoutButtons.forEach((button, index) => { button.disabled = initialDisabled[index]; });
        message.textContent = error.message || window.EL.error;
        cartButton.disabled = selectedAddons(container).length === 0;
        cartButton.textContent = window.EL.addSelected;
      }
    });
  });
  document.querySelectorAll('[data-product-root]').forEach(container => {
    const variants = JSON.parse(container.querySelector('[data-variants]').textContent);
    const select = container.querySelector('[data-variant-select]');
    const buttons = Array.from(container.querySelectorAll('[data-add-button]'));
    const form = container.querySelector('[data-product-form]');
    const purchaseBar = container.querySelector('[data-mobile-purchase]');
    const purchaseFinish = container.querySelector('[data-purchase-finish]');
    const purchaseTotal = container.querySelector('[data-purchase-total]');
    const finishOptions = container.querySelector('[data-finish-options]');
    const finishButtons = Array.from(container.querySelectorAll('[data-finish-id]'));
    let submitting = false;
    const price = container.querySelector('[data-variant-price]');
    const message = container.querySelector('[data-form-message]');
    const quantity = container.querySelector('input[name="quantity"]');
    const total = container.querySelector('[data-selection-total]');
    const slides = Array.from(container.querySelectorAll('[data-image-id]'));
    const photoDialog = container.querySelector('[data-photo-dialog]');
    const zoom = container.querySelector('[data-gallery-zoom]');
    const refreshPhotoDialog = () => {
      if (!photoDialog || !photoDialog.open) return;
      const active = slides.find(slide => !slide.hidden);
      const source = active && active.querySelector('img');
      if (!active || !source) return;
      const image = photoDialog.querySelector('[data-photo-image]');
      image.loading = 'eager';
      image.src = source.currentSrc || source.src || active.dataset.imageFull;
      image.alt = source.alt;
      photoDialog.querySelector('[data-photo-caption]').textContent = source.alt;
      const fullPhoto = new Image();
      fullPhoto.onload = () => { if (photoDialog.open && !active.hidden) image.src = fullPhoto.src; };
      fullPhoto.src = active.dataset.imageFull;
    };
    const refreshButtons = variant => {
      buttons.forEach(button => {
        button.disabled = submitting || !variant || !variant.available;
        button.textContent = submitting ? window.EL.adding : variant && variant.available ? window.EL.add : window.EL.sold;
      });
    };
    const refreshTotal = () => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      const formatted = money(variant.amount * Math.max(1, Number(quantity.value) || 1) + addonTotal(container));
      if (total) total.textContent = formatted;
      if (purchaseTotal) purchaseTotal.textContent = formatted;
      if (purchaseFinish) purchaseFinish.textContent = variant.title;
    };
    const showImage = id => {
      if (!container.querySelector('[data-image-id="' + id + '"]')) return;
      container.querySelectorAll('[data-image-id]').forEach(slide => { slide.hidden = String(slide.dataset.imageId) !== String(id); });
      container.querySelectorAll('[data-show-image]').forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb.dataset.showImage) === String(id) ? 'true' : 'false'); });
      const activeImage = container.querySelector('[data-image-id="' + id + '"]');
      if (zoom && activeImage.dataset.imageFull) zoom.href = activeImage.dataset.imageFull;
      const position = slides.indexOf(activeImage) + 1;
      container.querySelectorAll('[data-gallery-count], [data-photo-count]').forEach(counter => { counter.textContent = position + ' / ' + slides.length; });
      refreshPhotoDialog();
    };
    const selectImage = id => {
      const linkedVariant = variants.find(variant => String(variant.imageId) === String(id) && String(variant.id) === select.value) || variants.find(variant => String(variant.imageId) === String(id) && variant.available) || variants.find(variant => String(variant.imageId) === String(id));
      if (linkedVariant && String(linkedVariant.id) !== select.value) {
        select.value = String(linkedVariant.id);
        update();
      } else showImage(id);
    };
    container.querySelectorAll('[data-show-image]').forEach(thumb => thumb.addEventListener('click', () => selectImage(thumb.dataset.showImage)));
    const stage = container.querySelector('[data-gallery-stage]');
    const stepImage = direction => {
      const current = slides.findIndex(slide => !slide.hidden);
      if (slides.length) selectImage(slides[(current + direction + slides.length) % slides.length].dataset.imageId);
    };
    container.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => stepImage(Number(button.dataset.galleryStep))));
    const galleryNavigation = container.querySelector('[data-gallery-navigation]');
    if (galleryNavigation) galleryNavigation.hidden = false;
    if (photoDialog && zoom && typeof photoDialog.showModal === 'function') {
      zoom.addEventListener('click', event => {
        event.preventDefault();
        photoDialog.showModal();
        refreshPhotoDialog();
      });
      photoDialog.querySelector('[data-photo-close]').addEventListener('click', () => photoDialog.close());
      photoDialog.addEventListener('close', () => zoom.focus({ preventScroll: true }));
      photoDialog.addEventListener('click', event => {
        const bounds = photoDialog.getBoundingClientRect();
        if (event.target === photoDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) photoDialog.close();
      });
      photoDialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          stepImage(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    }
    if (stage) {
      let touchStart = null;
      stage.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          stepImage(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') touchStart = { x: event.clientX, y: event.clientY };
      }, { passive: true });
      stage.addEventListener('pointerup', event => {
        if (!touchStart) return;
        const dx = event.clientX - touchStart.x;
        const dy = event.clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) stepImage(dx < 0 ? 1 : -1);
      }, { passive: true });
      stage.addEventListener('pointercancel', () => { touchStart = null; }, { passive: true });
    }
    const update = () => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      price.textContent = variant.price;
      const selectedFinish = container.querySelector('[data-selected-finish]');
      if (selectedFinish) selectedFinish.textContent = variant.title;
      const availability = container.querySelector('[data-availability]');
      if (availability) {
        availability.textContent = variant.available ? window.EL.available : window.EL.sold;
        availability.classList.toggle('is-unavailable', !variant.available);
      }
      finishButtons.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.finishId === select.value)));
      refreshButtons(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      document.querySelectorAll('form[action$="/localization"] input[name="return_to"]').forEach(input => {
        input.value = url.pathname + url.search + url.hash;
      });
      showImage(variant.imageId);
      message.textContent = '';
      refreshTotal();
    };
    select.addEventListener('change', update);
    if (finishOptions) {
      finishOptions.hidden = false;
      select.hidden = true;
      finishButtons.forEach(choice => choice.addEventListener('click', () => {
        select.value = choice.dataset.finishId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    }
    quantity.addEventListener('input', refreshTotal);
    const quantityButtons = Array.from(container.querySelectorAll('[data-quantity-step]'));
    quantityButtons.forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        if (submitting) return;
        const value = Math.max(1, Math.floor(Number(quantity.value) || 1) + Number(button.dataset.quantityStep));
        quantity.value = String(value);
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    container.addEventListener('addons:change', refreshTotal);
    update();
    if (purchaseBar) {
      const buyRow = container.querySelector('.buy-row');
      if (buyRow && 'IntersectionObserver' in window) {
        const purchaseObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          purchaseBar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        purchaseObserver.observe(buyRow);
      } else purchaseBar.hidden = false;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const variant = variants.find(v => String(v.id) === select.value);
      if (submitting || !variant || !variant.available || !form.reportValidity()) return;
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      refreshButtons(variant);
      message.textContent = '';
      try {
        const data = new FormData(form);
        const items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) }, ...selectedAddons(container)];
        await postCart('add', { items });
        window.location.assign(root + 'cart');
      } catch (error) {
        message.textContent = error.message || window.EL.error;
        submitting = false;
        form.removeAttribute('aria-busy');
        refreshButtons(variants.find(v => String(v.id) === select.value));
      }
    });
  });
  document.querySelectorAll('[data-sort-select]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  const disclosures = Array.from(document.querySelectorAll('.mobile-menu, .region-switcher'));
  disclosures.forEach(disclosure => {
    disclosure.addEventListener('toggle', () => {
      if (disclosure.open) disclosures.forEach(other => { if (other !== disclosure) other.open = false; });
    });
    if (disclosure.classList.contains('mobile-menu')) disclosure.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => { disclosure.open = false; }));
  });
  document.addEventListener('click', event => disclosures.forEach(disclosure => {
    if (disclosure.open && !disclosure.contains(event.target)) disclosure.open = false;
  }));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') disclosures.forEach(disclosure => {
      if (disclosure.open) { disclosure.open = false; disclosure.querySelector('summary').focus(); }
    });
  });
  const grid = document.querySelector('[data-collection-grid]');
  const budget = document.querySelector('[data-budget-select]');
  if (budget && grid) {
    document.querySelector('[data-budget-control]').hidden = false;
    const cards = Array.from(grid.querySelectorAll('[data-product-price]'));
    const applyBudget = () => {
      cards.forEach(card => {
        const amount = Number(card.dataset.productPrice);
        card.hidden = budget.value === 'under-100' ? amount >= 10000 : budget.value === '100-300' ? amount < 10000 || amount > 30000 : budget.value === 'over-300' ? amount <= 30000 : false;
      });
      const count = cards.filter(card => !card.hidden).length;
      const result = document.querySelector('[data-result-count]');
      if (result) result.textContent = count === 1 ? window.EL.oneResult : window.EL.results.replace('__COUNT__', String(count));
      const empty = document.querySelector('[data-filter-empty]');
      if (empty) empty.hidden = count > 0;
      const url = new URL(window.location.href);
      if (budget.value === 'all') url.searchParams.delete('budget');
      else url.searchParams.set('budget', budget.value);
      history.replaceState({}, '', url);
      const budgetParam = document.querySelector('[data-budget-param]');
      if (budgetParam) {
        budgetParam.value = budget.value;
        budgetParam.disabled = budget.value === 'all';
      }
    };
    const initialBudget = new URL(window.location.href).searchParams.get('budget');
    budget.value = ['under-100', '100-300', 'over-300'].includes(initialBudget) ? initialBudget : 'all';
    budget.addEventListener('change', applyBudget);
    const reset = document.querySelector('[data-budget-reset]');
    if (reset) reset.addEventListener('click', () => { budget.value = 'all'; applyBudget(); budget.focus(); });
    applyBudget();
  }
});
